// extracted by mini-css-extract-plugin
export default {"pricing-table":"styles_pricing-table__buhoj","pricing-table__disclaimer":"styles_pricing-table__disclaimer__31DXk","pricing-table__row":"styles_pricing-table__row__0VWxR"};